// extracted by mini-css-extract-plugin
export var discard = "_7m-3";
export var muiTooltipTooltip = "_7m-5";
export var notificationBar = "_7m-2";
export var saveButtonHoverSlotWrapper = "_7m-4";
export var show = "_7m-1";
export var spacer = "_7m-0";